
export const liabilityBasisTypeCombinationGridConfig = {
  isRowSelectable: false,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "Basis Type",
      fieldName: "basisType",
      colStyle: {
        textAlign: "left",
        width:"79%",
      },
      allowShort: true,
    },
    {
      name: "Liability Basis",
      fieldName: "liabilityBasis",     
      colStyle: {
        textAlign: "center",
        width:"21%",
      },
      allowShort: true,
    },
  ],
};
